import { Box, HtmlViewer } from 'shared';

export const CoachingSessionRecapContent = ({
  content,
  color,
}: {
  content: string;
  color: string;
}) => (
  <Box maxH="130px" overflow="hidden">
    <HtmlViewer rawHtml={content} key={content} textColor={color} />
  </Box>
);
